<div class="main-wrapper">
  <div class="header-wrapper">
    <label
      [class]="[currentTab == 1 ? 'header-active' : 'header']"
      id="one-tab"
      for="one"
      (click)="selectTab(1)"
      >{{ 'UserParmaterFlyoutInformation' | t }}</label
    >
    <label
      [class]="[currentTab == 2 ? 'header-active' : 'header']"
      id="two-tab"
      for="two"
      (click)="selectTab(2)"
      >{{ 'ExportUserParameters' | t }}</label
    >
  </div>

  <table class="fault-table" *ngIf="currentTab == 1">
    <colgroup>
      <col span="1" style="width: 100px" />
      <col span="1" style="width: 80%" />
    </colgroup>
    <tr>
      <td>{{ 'ProjectWizardSubViewOverviewProjectName' | t }}</td>
      <td>{{ projectName }}</td>
    </tr>
    <!-- CURE SHEET PROVENANCE.
         Rendered ONLY when the project carries a ref. Absent is normal — the ref
         is operator-chosen and most projects (all of them, before the feature)
         have none — and an empty row would read as "no sheet was followed",
         which is a claim about the cure this data cannot support. -->
    <tr *ngIf="cureSheetRef">
      <td>{{ 'ProjectInformationCureSheet' | t }}</td>
      <td>
        <span class="cure-sheet-line" [class.cure-sheet-attention]="cureSheetNeedsAttention">
          {{ cureSheetLine }}
        </span>
        <!-- Bytes via HttpClient, never an href: the MSAL interceptor only sees
             HttpClient, so a link would send no bearer and 401 while looking
             correct in the markup. -->
        <button type="button" class="cure-sheet-open" (click)="openCureSheetPdf()">
          {{ 'ProjectInformationOpenPdf' | t }}
        </button>
        <div class="cure-sheet-error" *ngIf="cureSheetPdfError">{{ cureSheetPdfError }}</div>
      </td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationViscomLinerVersion' | t }}</td>
      <td>{{ versionLabel() }}</td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationDTSSerial' | t }}</td>
      <td>{{ this.tempData.SER }}</td>
    </tr>
    <tr>
      <td>{{ 'ProjectWizardSubViewOverviewFibre' | t }}</td>
      <td>{{ fiberLabel() }}</td>
    </tr>
    <tr>
      <td>{{ 'ProjectWizardSubViewPropertyListLength' | t }}</td>
      <td>
        {{ this.tempData.CRE - this.tempData.CRB
        }}<span *ngIf="projectService.isMetricUnit">m</span
        ><span *ngIf="!projectService.isMetricUnit">ft</span>
      </td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationCuringTemperature' | t }}</td>
      <td>
        {{ this.tempData.CT
        }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
        ><span *ngIf="!projectService.isMetricUnit">&deg;F</span>
      </td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationOverheatTemperature' | t }}</td>
      <td>
        {{ this.tempData.OT
        }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
        ><span *ngIf="!projectService.isMetricUnit">&deg;F</span>
      </td>
    </tr>
    <tr>
      <td>{{ 'ProjectMeasurementInformation' | t }}</td>
      <td>{{ this.tempData.MI }}s</td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationSampelingInterval' | t }}</td>
      <td>
        {{ samplingIntervalLabel() }}<span *ngIf="projectService.isMetricUnit">m</span
        ><span *ngIf="!projectService.isMetricUnit">ft</span>
      </td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationFirstMeasurement' | t }}</td>
      <td>{{ firstMeasurement | vcDate: 'seconds' }}</td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationLastMeasurement' | t }}</td>
      <td>{{ lastMeasurement | vcDate: 'seconds' }}</td>
    </tr>
    <tr>
      <td>{{ 'UserParmaterFlyoutInformationTraceCount' | t }}</td>
      <td>{{ this.tempData.TRC.length }}</td>
    </tr>
    <tr>
      <td>{{ 'ProjectInformationHeatInput' | t }}</td>
      <td>
        <ul class="heatmap-temp">
          <!-- HeatInput, not HMC: the server always sends HMC empty. -->
          <li *ngFor="let h of heatInputs">
            {{ h.temperature | number : "1.0-1"
            }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
            ><span *ngIf="!projectService.isMetricUnit">&deg;F</span> for
            {{ h.minutes }} min
          </li>
          <li *ngIf="heatInputs.length === 0">—</li>
        </ul>
      </td>
    </tr>
  </table>

  <!-- Params =========================================================== -->

  <table class="param-table" *ngIf="currentTab == 2">
    <colgroup>
      <col span="1" style="width: 250px" />
      <col span="1" />
    </colgroup>
    <!-- From the project-list row: the server always sends the telemetry U empty. -->
    <tr class="row-param" *ngFor="let pp of userParameters()">
      <td>{{ pp.Name }}</td>
      <td>{{ pp.Value }}</td>
    </tr>
    <tr class="row-param" *ngIf="userParameters().length === 0">
      <td>—</td>
      <td></td>
    </tr>
  </table>
</div>
